import React from 'react';

import { flagStyles } from '../settings';

const SvgTR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5328px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTR;
